import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { ConfirmedFilled } from '@one-thd/sui-icons';

export const AfterSubmitMessage = ({
  successStyleProps = {
    iconBgColor: 'success',
    textColor: 'success',
    successIconSize: 'small',
    successMessageVariant: 'body-sm',
  },
  icon: Icon = ConfirmedFilled,
  message = 'Thank you. Your feedback helps us improve your online shopping experience.',
  thanksMessageHideTime = null,
}) => {
  const [hideComponent, setHideComponent] = useState(false);

  useEffect(() => {
    if (thanksMessageHideTime) {
      setTimeout(() => {
        setHideComponent(true);
      }, thanksMessageHideTime);
    }
  }, []);

  if (hideComponent) return null;

  return (
    <div className="sui-flex sui-items-center sui-gap-2">
      <Icon color={successStyleProps.iconBgColor} size={successStyleProps.successIconSize} shrink={0} />
      <Typography variant={successStyleProps.successMessageVariant} height="tight" color={successStyleProps.textColor}>
        {message}
      </Typography>
    </div>
  );
};

AfterSubmitMessage.displayName = 'AfterSubmitMessage';

AfterSubmitMessage.propTypes = {
  successStyleProps: PropTypes.shape({
    iconBgColor: PropTypes.oneOf(['success', 'success-strong', 'danger', 'warning', 'info']),
    textColor: PropTypes.oneOf(['success', 'success-strong', 'danger', 'warning', 'info']),
    successIconSize: PropTypes.oneOf(['small', 'regular', 'large']),
    successMessageVariant: PropTypes.oneOf(['body-xs', 'body-sm', 'body-md', 'body-lg']),
  }),
  icon: PropTypes.shape({
    $$typeof: PropTypes.symbol,
    render: PropTypes.func,
  }),
  message: PropTypes.string,
  thanksMessageHideTime: PropTypes.number,
};
